<svelte:options customElement="clw-icon-minus" />

<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 9L14 9" stroke="white" stroke-width="1.5" stroke-linecap="round" />
</svg>
